/*
 *
 * LanguageProvider constants
 *
 */

export const CHANGE_LOCALE = 'library/LanguageToggle/CHANGE_LOCALE';

export const GET_LOCIZE_MESSAGE_REQUEST =
  'library/LanguageProvider/GET_LOCIZE_MESSAGE_REQUEST';
export const GET_LOCIZE_MESSAGE_SUCCESS =
  'library/LanguageProvider/GET_LOCIZE_MESSAGE_SUCCESS';
export const GET_LOCIZE_MESSAGE_FAILURE =
  'library/LanguageProvider/GET_LOCIZE_MESSAGE_FAILURE';
export const GET_LOCIZE_MESSAGE_SKIP =
  'library/LanguageProvider/GET_LOCIZE_MESSAGE_SKIP';

export const REQUEST = 'REQUEST';
export const COMPLETE = 'COMPLETE';
export const IDLE = 'IDLE';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';
export const DEFAULT_LOCALE = 'en';
 
export const GET_SUPPORTED_LOCALES_REQUEST =
  'library/GET_SUPPORTED_LOCALES_REQUEST';
export const GET_SUPPORTED_LOCALES_SUCCESS =
  'library/GET_SUPPORTED_LOCALES_SUCCESS';
export const GET_SUPPORTED_LOCALES_FAILURE =
  'library/GET_SUPPORTED_LOCALES_FAILURE';
export const GET_SUPPORTED_LOCALES_SKIP =
  'library/LanguageProvider/GET_SUPPORTED_LOCALES_SKIP';